var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.27 29.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d2a784;}.cls-2{fill:#1c2c58;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.64,
    cy: 14.64,
    r: 14.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,9.94a2.47,2.47,0,0,0-1.73-1.73,59.37,59.37,0,0,0-7.62-.4A59.51,59.51,0,0,0,7,8.21,2.44,2.44,0,0,0,5.29,9.94a25.28,25.28,0,0,0-.41,4.7,25.33,25.33,0,0,0,.41,4.7A2.43,2.43,0,0,0,7,21.06c1.52.41,7.63.41,7.63.41s6.1,0,7.62-.41A2.46,2.46,0,0,0,24,19.34a25.33,25.33,0,0,0,.41-4.7A25.28,25.28,0,0,0,24,9.94Zm-11.3,7.62V11.71l5.07,2.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.55de3c4590ea175b93a9b020e5a1d3f6.svg";
export { ForwardRef as ReactComponent };